import dayjs, { Dayjs } from "dayjs";

/** The display format every date-only picker/field uses. */
export const DATE_DISPLAY_FORMAT = "DD/MM/YYYY";

/** The display format every detail/Manage surface uses for date-times. */
export const DATE_TIME_DISPLAY_FORMAT = "DD/MM/YYYY HH:mm";

/** ISO date-time string → "DD/MM/YYYY HH:mm", or an em-dash when unset. */
export const fmtDateTime = (value?: string) =>
  value ? dayjs(value).format(DATE_TIME_DISPLAY_FORMAT) : "—";

/** Datetimepicker display formatter (Dayjs → "DD/MM/YYYY HH:mm"). */
export const dateTimeFormat = (value?: any) =>
  value ? (value as Dayjs).format(DATE_TIME_DISPLAY_FORMAT) : "";
